export type {
  SwitchBaseProps,
  SwitchBaseState,
  SwitchOnChangeData,
  SwitchProps,
  SwitchSlots,
  SwitchState,
} from './components/Switch/index';
export {
  Switch,
  renderSwitch_unstable,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  switchClassName,
  switchClassNames,
  useSwitchStyles_unstable,
  useSwitch_unstable,
  useSwitchBase_unstable,
} from './components/Switch/index';
